import { FilterOutlined } from "@ant-design/icons";
import React from "react";

const RuleConfDetails = ({ details }) => {
  const list = Object.keys(details);
  return (
    <div className="w-full p-3 bg-gray-50 rounded-md">
      <div className="mb-2 font-semibold text-gray-500">
        <FilterOutlined /> Candidate Criteria
      </div>
      {list.length === 0 ? (
        <div className="flex flex-col items-center gap-2 text-gray-500">
          <span className="text-sm">No conditions added yet</span>
          <span className="text-xs text-gray-400">Edit rule to create one</span>
        </div>
      ) : (
        <div className="flex flex-wrap gap-4">
          {list?.map((key) => (
            <div
              key={key}
              className="flex flex-col min-w-[160px] bg-white border rounded-md px-3 py-2 shadow-sm"
            >
              <label className="text-xs text-gray-500 uppercase mb-1">
                {key}
              </label>
              <span className="text-sm font-medium text-gray-800">
                {(() => {
                  const val = details[key];
                  const formatVal = (v) => {
                    if (v === null || v === undefined || v === "" || v === "null" || v === "undefined") {
                      return "NULL";
                    }
                    return v;
                  };
                  if (Array.isArray(val)) {
                    return val.map(formatVal).join(", ");
                  }
                  return formatVal(val);
                })()}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default RuleConfDetails;
